/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import cx from 'classnames';

import type { SpinnerProps } from '../../types';
import Icon from '../Icon/Icon';
import './Spinner.less';

const SpinnerIndicator = ({ size, label }: { size: NonNullable<SpinnerProps['size']>; label?: string }) => (
  <div role="status" aria-label={label ?? 'Loading'} className={cx('spinner', `spinner--${size}`)}>
    <Icon name="actionable/spinner" size={size} className="spinner__icon" />
    {label && <span className="spinner__label">{label}</span>}
  </div>
);

const Spinner = ({ spinning = true, size = 'medium', label, children, className }: SpinnerProps) => {
  if (!children) {
    return spinning ? <SpinnerIndicator size={size} label={label} /> : null;
  }

  return (
    <div className={cx('spinner-container', className)} aria-busy={spinning || undefined}>
      {spinning && (
        <div className="spinner-container__overlay">
          <SpinnerIndicator size={size} label={label} />
        </div>
      )}
      <div
        className={cx('spinner-container__content', spinning && 'spinner-container__content--dimmed')}
        aria-hidden={spinning || undefined}>
        {children}
      </div>
    </div>
  );
};

Spinner.displayName = 'Spinner';
export default Spinner;
